(function(gtmId){
    if (gtmId !== undefined) {
        const html = `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
        const template = document.createElement('template');
        template.innerHTML = html;
        document.body.prepend(template.content.firstChild);
    }
})(import.meta.env.VITE_GTM_ID);
